export const EfsHistoryRoute = {
  path: '/Accounting/EFSHistory',
  load: () => import('./EfsHistory'),
  protected: true,
};
